
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path d="M15.75 4C14.2312 4 13 5.23122 13 6.75V10.5H14.5C14.7761 10.5 15 10.7239 15 11V19C15 19.2761 14.7761 19.5 14.5 19.5H5C4.72386 19.5 4.5 19.2761 4.5 19V11C4.5 10.7239 4.72386 10.5 5 10.5H12V6.75C12 4.67893 13.6789 3 15.75 3C17.8211 3 19.5 4.67893 19.5 6.75V9H18.5V6.75C18.5 5.23122 17.2688 4 15.75 4Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiUnlockFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
